import { declareFont, defineFont, fontWeights } from '../utils/FontUtils';
var bbTtf = [{
  ext: 'ttf',
  format: 'truetype'
}];
export var declaration = {
  UniversRoman: {
    fontDir: 'BbComputer',
    fileBase: 'BB-Regular',
    fontFamily: 'BB-Regular',
    fontWeight: fontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
    formats: bbTtf
  },
  UniversCondensed: {
    fontDir: 'BbComputer',
    fileBase: 'BB-Cond',
    fontFamily: 'BB-Cond',
    fontWeight: fontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
    formats: bbTtf
  },
  UniversBoldCondensed: {
    fontDir: 'BbComputer',
    fileBase: 'BB-CondBold',
    fontFamily: 'BB-CondBold',
    fontWeight: fontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
    formats: bbTtf
  }
};
export default {
  UniversRoman: defineFont(declaration.UniversRoman),
  UniversCondensed: defineFont(declaration.UniversCondensed),
  UniversBoldCondensed: defineFont(declaration.UniversBoldCondensed)
};
export var fontsFaces = {
  '@font-face': Object.values(declaration).map(declareFont)
};